import { FormManager } from 'react-form-state-manager';
import useDebouncedEffect from './useDebouncedEffect';

const useTouchOnChange = (form: FormManager, attribute: string) => {
  useDebouncedEffect(() => {
    if (form.get(attribute)) {
      form.setTouched(attribute, true);
    }
  }, 500, [form.get(attribute)]);
};

export default useTouchOnChange;
